<form class="reg-form" [formGroup]="form" (submit)="submit()">
  <app-platforms-login></app-platforms-login>

  <mat-form-field appearance="outline">
    <input
      matInput
      [placeholder]=" 'authorization.yourLogin' | translate "
      formControlName="login"
    />
    <mat-error *ngIf="formErrorHandler('login', 'required')">{{ 'authorization.validationErrors.username.required' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <input
      matInput
      formControlName="password"
      [type]="passwordFieldType(isShowPassword)"
      [placeholder]=" 'authorization.yourPassword' | translate "
    />
    <a mat-icon-button matSuffix (click)="changePasswordVisibility()">
      <mat-icon>{{ iconName(isShowPassword) }}</mat-icon>
    </a>
    <mat-error *ngIf="formErrorHandler('password', 'required')">{{ 'authorization.validationErrors.password.required' | translate }}</mat-error>
    <mat-error *ngIf="formErrorHandler('password', 'minlength')">{{ 'authorization.validationErrors.password.minLength' | translate }}</mat-error>
    <mat-error *ngIf="formErrorHandler('password', 'maxlength')">{{ 'authorization.validationErrors.password.maxLength' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <input
      matInput
      formControlName="confirmPassword"
      [type]="passwordFieldType(isShowConfirmPassword)"
      [placeholder]=" 'authorization.yourConfirmPassword' | translate "
    />
    <a mat-icon-button matSuffix (click)="changeConfirmPasswordVisibility()">
      <mat-icon>{{ iconName(isShowConfirmPassword) }}</mat-icon>
    </a>
    <mat-error *ngIf="formErrorHandler('confirmPassword', 'required')">{{ 'authorization.validationErrors.confirmPassword.required' | translate }}</mat-error>
    <mat-error *ngIf="formErrorHandler('confirmPassword', 'mismatch')">{{ 'authorization.validationErrors.confirmPassword.dontMatch' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <input
      matInput
      [placeholder]=" 'authorization.yourEmail' | translate "
      formControlName="email"
    />
    <mat-error *ngIf="formErrorHandler('email', 'required')">{{ 'authorization.validationErrors.email.required' | translate }}</mat-error>
    <mat-error *ngIf="formErrorHandler('email', 'minlength')">{{ 'authorization.validationErrors.email.minLength' | translate }}</mat-error>
    <mat-error *ngIf="formErrorHandler('email', 'email')">{{ 'authorization.validationErrors.email.invalid' | translate }}</mat-error>
  </mat-form-field>

  <re-captcha (resolved)="resolveCaptcha($event)" siteKey="6LePzzsUAAAAAEJbPW7f37yuC3zBuFxrqe5X6z4a"></re-captcha>

  <button
    type="submit"
    class="login-form__submit"
    mat-flat-button
    color="primary"
    [disabled]="form.invalid"
  >
    {{ 'authorization.registrationButton' | translate }}
  </button>
</form>

<span class="agreements">
    {{ 'authorization.agreements.heading' | translate }}
  <a class="url">{{ 'authorization.agreements.agreementForStreamers' | translate }}</a>
  {{ 'authorization.agreements.agreementsAnd' | translate }}
  <a class="url">{{ 'authorization.agreements.privacyPolicy' | translate }}</a>
</span>
